// Cart drawer upsell: add the suggested item and re-render the drawer in place.
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-of-upsell]');
  if (!btn) return;
  e.preventDefault();
  btn.disabled = true;
  btn.textContent = 'Adding…';
  var drawer = document.querySelector('cart-drawer');
  fetch(window.routes.cart_add_url + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: Number(btn.dataset.ofUpsell), quantity: 1, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
  })
    .then(function (r) { return r.json(); })
    .then(function (state) {
      if (state.status) { btn.textContent = 'Unavailable'; return; }
      if (drawer && drawer.renderContents) drawer.renderContents(state); else window.location = window.routes.cart_url;
    })
    .catch(function () { window.location = window.routes.cart_url; });
});

// Duo upgrade: take one of the single item out, add the Duo, re-render the drawer.
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-of-upgrade]');
  if (!btn) return;
  e.preventDefault();
  btn.disabled = true;
  btn.textContent = 'Upgrading…';
  var drawer = document.querySelector('cart-drawer');
  var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
  fetch(window.routes.cart_change_url + '.js', {
    method: 'POST', headers: json,
    body: JSON.stringify({ id: btn.dataset.ofUpgrade, quantity: Number(btn.dataset.ofQty) })
  })
    .then(function () {
      return fetch(window.routes.cart_add_url + '.js', {
        method: 'POST', headers: json,
        body: JSON.stringify({ id: Number(btn.dataset.ofDuo), quantity: 1, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
      });
    })
    .then(function (r) { return r.json(); })
    .then(function (state) {
      if (state.status) { window.location = window.routes.cart_url; return; }
      if (drawer && drawer.renderContents) drawer.renderContents(state); else window.location = window.routes.cart_url;
    })
    .catch(function () { window.location = window.routes.cart_url; });
});
